import React from 'react'
import TableDetail from '../../TableDetail/TableDetail'
import SectionCollapse from '../../../../../section/SectionCollapse'
import { ChildrenInformation, ParentInformation } from '../../../../../skeleton/UserFormSkeleton'

const CreatedUser = ({ detail }) => {
  return (
    <>
      <SectionCollapse title="basic information">
        <TableDetail
          detail={{
            _id: detail._id,
            code: detail.code,
            firstName: detail.firstName,
            lastName: detail.lastName,
            email: detail.email,
            roles: detail.roles,
            preferredName: detail.preferredName,
            title: detail.title,
            gender: detail.gender,
            birthdate: detail.birthdate,
          }}
        />
      </SectionCollapse>
      <SectionCollapse title="contact information">
        <TableDetail
          detail={{
            mobile: detail.telephone,
            address: detail.address,
            country: detail.country,
            state: detail.state,
            city: detail.city,
            postalCode: detail.postalCode,
          }}
        />
      </SectionCollapse>
      { detail?.roles?.some(role => role.name === 'Student') &&
        <SectionCollapse title="student information">
          <TableDetail
            detail={{
              yearLevel: detail.yearLevel,
              graduationYear: detail.graduationYear,
              form: detail.form,
              house: detail.house
            }}
          />
        </SectionCollapse>
      }
      { detail?.roles?.some(role => role.name === 'Student') &&
        <ParentInformation detail={detail.parents} />
      }
      { detail?.roles?.some(role => role.name === 'Parent') &&
        <ChildrenInformation detail={detail.children} />
      }
    </>
  )
}

export default CreatedUser